import fetch from 'unfetch'
import { ApolloClient } from 'apollo-client'
import { createHttpLink } from 'apollo-link-http'
import { ApolloLink, concat } from 'apollo-link'
import { InMemoryCache } from 'apollo-cache-inmemory'
import { GRAPHQL_ENDPOINT } from '../endpoints'

export default function createGraphQLClient(rootState) {
  const authMiddleware = new ApolloLink((operation, forward) => {
    // add the authorization to the headers
    operation.setContext({
      headers: {
        'x-access-token': rootState.auth.currentUser
          ? rootState.auth.currentUser.token
          : null,
      },
    })
    return forward(operation)
  })

  // Base GraphQL link
  const httpLink = createHttpLink({
    uri: GRAPHQL_ENDPOINT,
    fetch: fetch,
  })

  return new ApolloClient({
    // Provide the URL to the API server.
    link: concat(authMiddleware, httpLink),
    // Using a cache for blazingly
    // fast subsequent queries.
    cache: new InMemoryCache(),
  })
}
